import { useState, useEffect } from 'react';
import { Series, delayRender, continueRender } from 'remotion';
import { RenderModeProvider } from '../contexts/render-mode-context';
import SceneRenderer from './scene-renderer';
import OverlayLayer from './overlay-layer';
import { calcDuration } from '../utils/duration-calculator';
import { ensureFontsLoaded } from '../utils/load-fonts';
import { highlighterPromise } from '../utils/shiki-highlighter';

export default function SimulatorVideo({ scenario }) {
  const { scenes, fps = 60, projectName = 'HelloWorld', width = 1920, height = 1080, subtitles = true } = scenario;
  const [handle] = useState(() => delayRender('Loading fonts and Shiki...'));

  useEffect(() => {
    Promise.all([ensureFontsLoaded(), highlighterPromise])
      .then(() => continueRender(handle))
      .catch(() => continueRender(handle));
  }, [handle]);

  return (
    <RenderModeProvider value="video">
      <div style={{
        width: '100%', height: '100%',
        background: '#1e1e1e', color: '#cccccc',
        fontFamily: "'Segoe UI', system-ui, sans-serif",
        overflow: 'hidden', position: 'relative',
      }}>
        <Series>
          {scenes.map((scene, i) => {
            const duration = scene.durationInFrames || calcDuration(scene, fps);
            return (
              <Series.Sequence key={scene.id || `scene-${i}`} durationInFrames={duration}>
                <SceneRenderer scene={scene} projectName={projectName} fps={fps} />
              </Series.Sequence>
            );
          })}
        </Series>
        <OverlayLayer scenes={scenes} fps={fps} resolution={{ width, height }} showSubtitles={subtitles} />
      </div>
    </RenderModeProvider>
  );
}
